module.exports = __webpack_public_path__ + "it_IT-header-eb17a9.webp";